import { useEnabledFeatures } from '~/common/hooks/enabled-features';
import { AttachmentsPanelType } from '../types';

export function useAttachmentsAbilities(type: AttachmentsPanelType) {
    const {
        addBoloAttachments,
        deleteBoloAttachments,
        addEventAttachments,
        deleteEventAttachments,
    } = useEnabledFeatures();

    return {
        canAddAttachments: type === 'BOLO' ? addBoloAttachments : addEventAttachments,
        canDeleteAttachments: type === 'BOLO' ? deleteBoloAttachments : deleteEventAttachments,
    };
}
